import { PillGroup } from '@synotis/ui';

/**
 * Pills cliquables pour filtrer Actifs / Archivés / Tous.
 * Rendu porté par le PillGroup du paquet commun @synotis/ui (synotis-support#4) ;
 * ce fichier ne garde que les options partagées par les vues.
 */
const OPTIONS = [
  { value: 'active', label: 'Actifs' },
  { value: 'archived', label: 'Archivés' },
  { value: 'all', label: 'Tous' },
];

export default function ArchivedFilter({ value, onChange }) {
  return <PillGroup size="sm" options={OPTIONS} value={value} onChange={onChange} ariaLabel="Filtre d'archivage" />;
}
